import { Tab } from "../../models/tab";
import { SidenavService } from "../../services/sidenav.service";
import { Router } from "@angular/router";
import { AdminService } from "../../services/admin.service";
var SidenavComponent = /** @class */ (function () {
    function SidenavComponent(adminService, router, sidenavService) {
        this.adminService = adminService;
        this.router = router;
        this.sidenavService = sidenavService;
    }
    Object.defineProperty(SidenavComponent.prototype, "isOpened", {
        get: function () {
            return this.opened ? "show" : "hide";
        },
        enumerable: true,
        configurable: true
    });
    SidenavComponent.prototype.ngOnInit = function () {
        this.sidenavService.setSidenav(this);
        this.setTabs();
    };
    SidenavComponent.prototype.ngAfterViewInit = function () { };
    /**
     * Open the sidenav
     */
    SidenavComponent.prototype.open = function () {
        this.opened = true;
    };
    /**
     * Close the sidenav
     */
    SidenavComponent.prototype.close = function () {
        this.opened = false;
    };
    /**
     * Toggle the sidenav
     */
    SidenavComponent.prototype.toggle = function () {
        this.opened = !this.opened;
    };
    /**
     * Set the tabs (icon, title, link, componentName and visibility according to user profile / privilege)
     */
    SidenavComponent.prototype.setTabs = function () {
        var _this = this;
        this.adminService.init().subscribe(function () {
            _this.tabs = [];
            _this.tabs.push(new Tab({
                icon: "speaker_notes",
                title: "Program Articles",
                link: "/program-articles",
                componentNames: [
                    "Program Article Digital",
                    "Program Article Press",
                    "Program Article Popup Next",
                    "Program Article Partners",
                ],
                visibility: _this.adminService.can("Program Article Digital", "View") ||
                    _this.adminService.can("Program Article Press", "View") ||
                    _this.adminService.can("Program Article Popup Next", "View") ||
                    _this.adminService.can("Program Article Partners", "View"),
            }));
            _this.tabs.push(new Tab({
                icon: "directions_run",
                title: "Event Article",
                link: "/event-article",
                componentNames: ["Event Article"],
                visibility: _this.adminService.can("Event Article", "View"),
            }));
            _this.tabs.push(new Tab({
                icon: "translate",
                title: "Translate",
                link: "/translate",
                componentNames: ["Translate"],
                visibility: _this.adminService.can("Translate", "View"),
            }));
            _this.tabs.push(new Tab({
                icon: "flash_on",
                title: "Magic Box",
                link: "/magicbox",
                componentNames: [
                    "Magic Box Digital",
                    "Magic Box Press",
                    "Magic Box Popup Next",
                    "Magic Box Partners",
                ],
                visibility: _this.adminService.can("Magic Box Digital", "View") ||
                    _this.adminService.can("Magic Box Press", "View") ||
                    _this.adminService.can("Magic Box Popup Next", "View") ||
                    _this.adminService.can("Magic Box Partners", "View"),
            }));
            _this.tabs.push(new Tab({
                icon: "adjust",
                title: "TNT Sports",
                link: "/tnt-sports",
                componentNames: ["TNT Sports"],
                visibility: _this.adminService.can("BT Sport", "View"),
            }));
            _this.tabs.push(new Tab({
                icon: "dashboard",
                title: "Dashboard",
                link: "/dashboard",
                componentNames: ["Dashboard"],
                visibility: _this.adminService.can("Dashboard", "View"),
            }));
            _this.tabs.push(new Tab({
                icon: "security",
                title: "Admin",
                link: "/admin",
                componentNames: ["Admin Panel"],
                visibility: _this.adminService.can("Admin Panel", "View"),
            }));
            _this.tabs = _this.tabs.filter(function (tab) { return tab.visibility; });
        });
    };
    SidenavComponent.prototype.changeTab = function (tab) {
        this.tabs.forEach(function (elem) {
            elem.currentTab = false;
        });
        tab.currentTab = true;
        this.router.navigate([tab.link]);
    };
    return SidenavComponent;
}());
export { SidenavComponent };



// WEBPACK FOOTER //
// ./src/app/components/sidenav/sidenav.component.ts.pre-build-optimizer.js